import React from "react";
import styled from "@emotion/styled";

type SidebarProps = {
  open: boolean;
  children?: React.ReactNode;
};

function Sidebar({ open, children }: SidebarProps) {
  return (
    <SidebarWrapper open={open}>
      <div>{children}</div>
    </SidebarWrapper>
  );
}

const SidebarWrapper = styled.div<{ open: boolean }>(({ theme, open }) => ({
  width: open ? "350px" : "0px",
  minWidth: 0,
  height: "100%",
  backgroundColor: theme.colors.sysBackgroundDefault,
  overflow: "hidden",
  transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  display: "flex",
  flexDirection: "column",
  borderRight: open ? `1px solid ${theme.colors.sysBorderPrimary}` : 0,
  borderBottom: open ? `1px solid ${theme.colors.sysBorderPrimary}` : 0,
}));

export default Sidebar;
